import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectionStrategy
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { NewNavbarComponent } from './navbar/new-navbar.component';
import { FooterComponent } from './footer/footer.component';

@Component({
  selector: 'app-static-website-landing-page',
  templateUrl: './static-website-landing-page.component.html',
  styleUrls: ['./static-website-landing-page.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, RouterOutlet, NewNavbarComponent, FooterComponent]
})
export class StaticWebsiteLandingPageComponent implements OnInit, OnDestroy {
  currentRoute: string = '';

  ngOnInit() {
    localStorage.setItem('isStaticPage', 'true');
  }

  ngOnDestroy() {
    localStorage.removeItem('isStaticPage');
  }
}
